import React, { useState } from "react";
import "./Detail.css";
import { Col, Row } from "react-bootstrap";
import { FaPhone, FaUser } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
const Detail = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [message, setMessage] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    // Validation (simple example)
    if (!formData.name || !formData.phone || !formData.email) {
      setMessage("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "http://localhost:4000/api/send-mail",
        formData
      );
      setMessage(response.data.message || "Request sent successfully!");
    } catch (error) {
      setMessage("Failed to send the request. Please try again.");
    }
  };
  return (
    <section className="space shape-mockup-wrap">
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-lg-7">
            <div className="page-single">
              <div className="page-meta" style={{ marginTop: "0px" }}>
                <Link className="page-tag">
                Rhinoplasty (Nose Reshaping Surgery)
                </Link>{" "}
              </div>
              {/* <div className="service-img">
                <img
                  src="https://html.themeholy.com/tourm/demo/assets/img/destination/destination-details.jpg"
                  alt=""
                  style={{height:'400px'}}
                />
              </div> */}
              <div className="page-content d-block">
                {/* <h2 className="box-title">
                Surgery Saathi: Expert Rhinoplasty Services in Delhi
                </h2> */}
                <h3>What is Rhinoplasty?</h3>
                <p className="box-text mb-30 detail-page-paraas">
                  Rhinoplasty, or a "nose job," is a cosmetic surgery that
                  changes the shape or size of your nose. It's a popular
                  procedure that can improve the overall balance of your face or
                  fix breathing issues caused by the nose's internal structure.
                </p>

                <div className="service-inner-img mb-40">
                  <img
                  src="/Images/rhino.jpg"
                    // src="https://img.freepik.com/premium-photo/doctor-conducting-virtual-consultation-with-patient_1280275-220305.jpg?w=900"
                    alt=""
                    style={{ height: "300px", objectFit: "cover" }}
                  />
                </div>
                <p
                  className="box-text mb-30 detail-page-paraas"
                  style={{
                    background: "aliceblue",
                    padding: "10px",
                    fontStyle: "italic",
                  }}
                >
                  Rhinoplasty is performed for many reasons, such as to repair
                  the nose after an injury or trauma, correct birth defects, and
                  enhance the appearance of the nose.
                </p>
                <h2 className="box-title">Why Consider Rhinoplasty?</h2>
                <h4 style={{ fontSize: "18px", fontWeight: "400" }}>
                  People choose rhinoplasty for many reasons, including:
                </h4>
                <div className="checklist" style={{ marginTop: "20px" }}>
                  <ul>
                    <li>Adjusting the size or shape of the nose</li>
                    <li>Enlarged or drooping nasal tips.</li>
                    {/* <li>
                      Expert guide always guide you and give informations.
                    </li> */}
                    <li>Changing the width of the nose or nostrils</li>
                    {/* <li>Helping all traveler for Money Exchange.</li> */}
                    <li>Smoothing out a bump or correcting a crooked nose</li>
                    <li>Fixing a deviated septum to improve breathing</li>
                  </ul>
                </div>
              </div>
              {/* <p className="box-text mb-30 detail-page-paraas">
                For those seeking to enhance appearance, surgery is typically
                recommended only after nasal growth has completed, while
                functional corrections can be performed at a younger age.
              </p> */}
              <div className="th-comments-wrap style2">
                <h2 className="blog-inner-title h4">
                  Rhinoplasty can be done using two main techniques:
                </h2>
                <ul className="comment-list">
                  <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <h3 className="name">Open Rhinoplasty:</h3>
                        <p className="text">
                          The surgeon makes a small cut between the nostrils to
                          lift the skin and reshape the nose.
                        </p>
                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">Closed Rhinoplasty:</h3>
                            </div>
                            <p className="text">
                              All cuts are made inside the nose, so no visible
                              scars remain.
                            </p>
                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  {/* <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <div className="">
                          <h3 className="name">Photographic Documentation</h3>
                        </div>
                        <p className="text">
                          Photos will be taken from various angles for pre- and
                          post-surgery comparison, aiding in discussion of
                          surgical goals.
                        </p>
                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                  </li> */}
                </ul>
              </div>

              <div style={{ marginTop: "50px" }}>
                <h2
                  className="box-title"
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    background: "aliceblue",
                    padding: "10px",
                  }}
                >
                  The procedure takes around 2-3 hours and is done under
                  anesthesia to make you comfortable.
                </h2>
              </div>
              {/* <div>
                <p
                  className="box-text detail-page-paraas"
                  style={{ margin: "5px" }}
                >
                  Involves a small incision at the base of the nose, providing
                  greater visibility and access for extensive reshaping. This
                  technique is ideal for significant alterations.
                </p>
                <div className="checklist" style={{ marginTop: "15px" }}>
                  <ul>
                    <li>
                      Autologous cartilage grafts taken from the nasal septum
                      (the wall inside the nose that divides one air passage
                      from the other) offers the best chance for a natural
                      result. If cartilage and bone have already been removed
                      from the nasal septum, then ear or rib cartilage and
                      sometimes bone from the skull are other options.
                    </li>
                    <li>
                      Although solid silicone implants are available for nasal
                      surgery, these are foreign materials that may become
                      infected or react poorly with the nasal tissues and have
                      to be removed. That is why natural cartilage, if a supply
                      is available, is the most trouble-free option.
                    </li>

                    <li>
                      Fillers or fat grafts may also be injected to smooth the
                      nose, to camouflage deformities or indentations, or to add
                      volume in desired areas.
                    </li>
                  </ul>
                </div>
              </div> */}
              <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Recovery</h2>
                <p
                  className="box-text detail-page-paraas"
                  style={{ margin: "5px" }}
                >
                  After surgery, there may be swelling and bruising around your
                  nose and eyes. A splint is usually placed on the nose for
                  about a week to support the new shape. You can return to
                  normal activities in 1-2 weeks, but it can take a few months
                  for all the swelling to go down and the final results to show.
                </p>
                {/* <div
                  className="procedure-checklist"
                  style={{ marginTop: "15px", listStyle: "none" }}
                >
                  <ul>
                    <li>
                      1. <b>Administration of Anesthesia:</b> The patient
                      receives either local or general anesthesia, depending on
                      the complexity of the surgery.
                    </li>
                    <li>
                      <b>2. Making Incision:</b> An incision is created, either
                      inside the nose, at the base, or between the nostrils,
                      depending on the chosen technique.
                    </li>
                    <li>
                      <b>3. Reshaping the Nose Structure:</b> The surgeon
                      readjusts the bone and cartilage underneath the skin.
                      Cartilage may be taken from within the nose, the ear, or,
                      in rare cases, the ribs, minimizing the risk of immune
                      rejection.
                    </li>
                    <li>
                      <b>4. Deviated Septum Correction:</b> If necessary, the
                      surgery corrects any crooked or deviated septum to improve
                      breathing
                    </li>
                    <li>
                      <b>5. Closing the Incision:</b> The surgeon replaces the
                      nose skin and tissue, stitching the incision closed.
                    </li>
                    <li>
                      <b>6. Applying Bandages:</b> Bandages are applied to cover
                      the treated area, supporting the healing process.
                    </li>
                    <li>
                      <b>7. Supporting Garment:</b> A splint or gauze is worn
                      for a few weeks, and patients should follow their
                      surgeon's post-operative instructions to promote healing.
                    </li>
                  </ul>
                </div> */}
              </div>
              <h2
                className="box-title"
                style={{ fontSize: "20px", margin: "10px 0px" }}
              >
                Benefits of Rhinoplasty:
              </h2>
              {/* <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Post-Operative Care</h2>
              </div> */}
              <div>
                <div className="checklist" style={{ marginTop: "15px" }}>
                  <ul>
                    <li>Enhances facial appearance.</li>
                    <li>Increases self-confidence.</li>

                    <li>Corrects breathing difficulties.</li>
                  </ul>
                </div>
              </div>

              {/* <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Expected Results and Recovery</h2>
              </div> */}
              {/* <p
                className="box-text detail-page-paraas"
                style={{ margin: "5px" }}
              >
                Swelling generally subsides within weeks, with final results
                becoming clear over time. Most patients can return to daily
                activities within a week, while strenuous activities should be
                avoided for about two to three weeks.
              </p> */}
            </div>
          </div>
          <div className="col-xxl-4 col-lg-5">
            <aside className="sidebar-area style3">
              <div className="breakcrumbss">
                <div className="aside-detail-firstdivc">Popular Services</div>
                <ul className="detail-page-uls">
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/rhinoplasty">Rhinoplasty</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/gynecomastia">Gynecomastia</Link>
                  </li>

                  <li className="detail-pager-frst-ul-li">
                    <Link to="/lipoma-removal">Lipoma Removal</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/ophthalmology">Ophthalmology</Link>
                  </li>
                </ul>
              </div>
              <div className="breakcrumbss" style={{ marginTop: "30px" }}>
                <div className="aside-detail-firstdivc">Get Appointment</div>
                <form onSubmit={handleSubmit}>
                  <Row style={{ marginTop: "30px" }}>
                    <Col md={12} style={{ position: "relative" }}>
                      <FaUser
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="name"
                          className="aside-input-appointement"
                          placeholder="Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <FaPhone
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="phone"
                          className="aside-input-appointement"
                          placeholder="Mobile Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <MdEmail
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="email"
                          name="email"
                          className="aside-input-appointement"
                          placeholder="Email Id"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12}>
                      <button type="submit" className="aside-appointment-btn">
                        Get Appointment
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Detail;
